import { createFileRoute } from "@tanstack/react-router";
import { z } from "zod";
import ReceivingWorkspace from "@/features/inventory/ReceivingWorkspace";
import { InvPurchaseOrderId, InvPurchaseOrderItemId } from "@brewbase/db/types";

export const Route = createFileRoute("/inventory/receiving")({
  validateSearch: z
    .object({
      po: z.coerce
        .number()
        .transform((v) => v as InvPurchaseOrderId)
        .optional(),
      poi: z.coerce
        .number()
        .transform((v) => v as InvPurchaseOrderItemId)
        .optional(),
    })
    .optional(),
  component: ReceivingWorkspacePage,
});

function ReceivingWorkspacePage() {
  const { po, poi } = Route.useSearch() ?? {};
  return (
    <ReceivingWorkspace
      poFilter={po}
      initialPoISelection={poi}
      asModal={false}
    />
  );
}
